export enum ReferralType
{
    None = 0,
    VumatelReferral = 1,
    CelerityReferral = 2
}